import styled from 'styled-components';
import Button from 'components/Button';
import { Form } from 'formik';

export const SaveButton = styled(Button)`
  margin-right: 1.5rem;
`;

export const RoleSelector = styled(Form)`
  display: flex;
  align-items: center;
`;
